<template>
  <div>
    <div class="columns">
      <div class="column is-one-quarter">
        <b-message type="is-info">
          Set the switches below to your desired state and click Synchronize above.
        </b-message>
        <template v-if="$hasRole('Super User,Kymeta Admin,Product Support,Account Admin')">
          <b-field label="Provisioned" class="is-unselectable">
            <b-switch 
            :disabled="terminal.provisioned ? true : !canProvision"
            :title="terminal.provisioned ? 'You cannot deprovision a Terminal.': ''"
            :value="terminal.provisioned"
            @input="executeCommand(terminal.provisioned ? 'deprovision' : 'provision')">
            {{terminal.provisioned ? 'Yes' : 'No'}}
            </b-switch>
          </b-field>
          <b-field label="Activated">
            <b-tooltip label="Sync in progress with NMS." :active="terminal.syncInProgress" position="is-right" type="is-warning">
              <b-switch 
              :disabled="!terminal.provisioned || !canActivate || terminal.syncInProgress"
              :value="terminal.activeSubscription && terminal.activated" 
              @input="executeCommand(terminal.activated ? 'deactivate' : 'activate')">
                {{terminal.activated ? 'Yes' : 'No'}}
              </b-switch>
            </b-tooltip>
          </b-field>
          <b-field label="Allow Cell Traffic">
            <b-switch :value="terminal.enableCellTraffic" @input="executeCommand(terminal.enableCellTraffic ? 'disableCellTraffic':'enableCellTraffic', terminal.enableCellTraffic)">
              {{terminal.enableCellTraffic ? 'Yes' : 'No'}}
            </b-switch>
          </b-field>
        </template>
      </div>
      <div class="column is-three-quarters">
        <TerminalRichStateComponent />
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useTerminalsStore } from '../terminals-store';
import TerminalRichStateComponent from './TerminalRichStateComponent.vue';

const store = useTerminalsStore();
const terminal = computed(() => store.state.terminal);

// #region Switch conditionals
const canProvision = computed(() => terminal?.value?.activeSubscription && terminal?.value?.activeSubscription?.canProvision);
const canActivate = computed(() => terminal?.value?.activeSubscription && terminal?.value?.activeSubscription?.canActivate);
// #endregion

const executeCommand = async (cmd) => {
  await store.dispatch('executeTerminalCommand', { id: terminal.value.id, cmd });
}

</script>
<style lang="scss">
@import '../../styles/_mixins';

.kpt-nms-state-grid {
  @include display-grid;
  grid-template-columns: 200px 1fr 1fr;
}
</style>
